import { generateUtilityClass, generateUtilityClasses } from '@ori-ui/mui-bundle/base';
export function getDialogUtilityClass(slot) {
  return generateUtilityClass('MuiOriDialog', slot);
}
export const dialogClasses = generateUtilityClasses('MuiOriDialog', ['root', 'backButton', 'backdrop', 'closeButton', 'content', 'dialogGrid', 'header', 'sizeMedium', 'sizeSmall']);
export default dialogClasses;
//# sourceMappingURL=dialogClasses.js.map